//------------------------- Name -------------------------//
export const setName = async (name) => {
  try {
    localStorage.setItem("name", name);
  } catch (error) {
    console.log("error settng name", error);
  }
};

export const getName = async () => {
  try {
    let name = localStorage.getItem("name");
    return name;
  } catch (error) {
    console.log("error getting name", error);
  }
};

//------------------------- Profile -------------------------//
export const setProfile = async (profile) => {
  try {
    localStorage.setItem("profile", profile);
  } catch (error) {
    console.log("Error setting profile", error);
  }
};

export const getProfile = async () => {
  try {
    let profile = localStorage.getItem("profile");
    return profile;
  } catch (error) {
    console.log("Error getting profile", error);
  }
};

//------------------------- Token -------------------------//
export const setToken = async (token) => {
  try {
    localStorage.setItem("access_token", token);
    console.log('settoken',token)
  } catch (error) {
    console.log("Error setting token", error);
  }
};

export const getToken = async () => {
  try {
    const token = localStorage.getItem("access_token");
    if (!token) return null;

    // Decode JWT to extract expiry time
    // const payload = JSON.parse(atob(token.split(".")[1]));
    // const isExpired = payload.exp * 1000 < Date.now(); // Convert to milliseconds and compare
    // if (isExpired) {
    //   localStorage.removeItem("access_token"); // Clear expired token
    //   console.log("Token expired. Clearing localStorage.");
    //   return null;
    // }
    console.log('token',token)
    return token;
  } catch (error) {
    console.log("Error getting or validating token", error);
    return null;
  }
};
export const removeToken = () => {
  localStorage.removeItem("access_token");
}
//------------------------- UserID -------------------------//
export const setUserID = async (userId) => {
  try {
    localStorage.setItem("user_id", userId);
  } catch (error) {
    console.log("Error setting userID", error);
  }
};

export const getUserID = async () => {
  try {
    let userId = localStorage.getItem("user_id");
    return userId;
  } catch (error) {
    console.log("Error getting userID", error);
  }
};

//------ checking whether they downloaded the build ------//
// export const setDownloadCount = async (downloadCount) => {
//   try {
//     localStorage.setItem("downloadCheck", downloadCount);
//   } catch (error) {
//     console.log("Error setting download check", error);
//   }
// };

// export const getDownloadCount = async () => {
//   try {
//     let token = localStorage.getItem("downloadCheck");
//     return token;
//   } catch (error) {
//     console.log("Error getting download check", error);
//   }
// };
